import { render } from "./onboarding-consultation.vue?vue&type=template&id=6cddf550"
import script from "./onboarding-consultation.vue?vue&type=script&lang=js"
export * from "./onboarding-consultation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__